export default {
  groups: {
    generalData: 'Dados gerais',
    hero: 'Hero',
    intro: 'Introdução',
    activity: 'Áreas de Atividade',
    mv: 'Missão e Visão',
    mvv: 'Missão, Visão e Valores',
    value_proposition: 'Proposta de Valor',
    built_solution: 'Solução Construída',
    cta: 'CTA',
  },
  fields:{
    descrição: 'Descrição',
    display_order: 'Ordem de exibição',
    know_more: 'Saiba mais',
    title: 'Título',
  }
}